export enum UnitSystem {
  IMPERIAL = 'IMPERIAL',
  METRIC = 'METRIC',
}
